/**
 * Convierte un código ISO 3166-1 alpha-2 (ej. "CO") al emoji de bandera
 * correspondiente (🇨🇴). Usa los puntos Unicode "Regional Indicator
 * Symbol": cada letra A-Z mapea a un código 0x1F1E6 + (letra - 'A').
 *
 * Retorna cadena vacía si el input no son exactamente 2 letras A-Z — la
 * mayoría de renderers muestran los símbolos individuales si metes algo
 * inválido, preferimos devolver "" y que la UI decida el fallback.
 */
export function codeToFlag(code: string): string {
  if (!code) return '';
  const upper = code.trim().toUpperCase();
  if (upper.length !== 2) return '';
  if (!/^[A-Z]{2}$/.test(upper)) return '';

  const base = 0x1f1e6; // 'A' as regional indicator
  const a = base + (upper.charCodeAt(0) - 65);
  const b = base + (upper.charCodeAt(1) - 65);
  return String.fromCodePoint(a, b);
}
